module.exports = __webpack_public_path__ + "img/微看宝宝.c29552f5.png";